import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";
import axios from 'axios';

const initialUtilityState = {
    showMenu: window.innerWidth >= 1200,
    isLoading: true,
    dateInfo: {},
    dateInfoStatus: "idle", // 'idle' | 'loading' | 'success' | 'failed'
    dateError: null,
    themes: [
        {
            id: 1,
            name: "light",
            icon: "sun",
            selected: true,
        },
        {
            id: 2,
            name: "dark",
            icon: "moon",
            selected: false,
        }
    ]
};

export const fetchDate = createAsyncThunk('utility/fetchDate', async () => {
    try {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const response = await axios.get(`https://worldtimeapi.org/api/timezone/${tz}`);
        return {...response}
    } catch (error) {
        if (error.response) return error.response;
        throw error
    }
});

export const changeTheme = createAsyncThunk('utility/changeTheme ', async (initialState) => {
    await localStorage.setItem('theme',initialState);
    return initialState;
});


export const fetchTheme = createAsyncThunk('utility/fetchTheme ', async () => {
    return localStorage.getItem('theme');
});


const utilitySlice = createSlice({
    name: "utility",
    initialState: initialUtilityState,
    reducers: {
        changeShowMenu(state) {
            state.showMenu = !state.showMenu
        },
        setLoading(state, action) {
            state.isLoading = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            // fetch date from world time api
            .addCase(fetchDate.pending, (state) => {
                state.dateInfoStatus = 'loading';
            })
            .addCase(fetchDate.fulfilled, (state, action) => {
                if (action.payload.status === 200) {
                    state.dateInfoStatus = 'success';
                    state.dateInfo  = {
                        clientIp: action.payload.data.client_ip,
                        dateTime: action.payload.data.datetime,
                        dayOfWeek: action.payload.data.day_of_week,
                        dayOfYear: action.payload.data.day_of_year,
                        weekNumber: action.payload.data.week_number,
                        timeZone: action.payload.data.timezone,
                        unixTime: action.payload.data.unixtime,
                        utcDateTime: action.payload.data.utc_datetime,
                        utcOffset: action.payload.data.utc_offset,
                        timeDiff: new Date().getTime() - new Date(action.payload.data.datetime).getTime(),
                    }
                } else if(action.payload.data.error){
                    state.dateInfoStatus = 'failed';
                    state.dateError = action.payload.data.error;
                } else {
                    state.dateInfoStatus = 'failed';
                    state.dateError = action.payload.statusText;
                }
            })
            .addCase(fetchDate.rejected, (state, action) => {
                state.dateInfoStatus = 'failed';
                state.dateError = action.error.message;
            })

            // Change theme
            .addCase(changeTheme.fulfilled, (state, action) => {
                state.themes.map(item => {
                    if (item.id === action.payload) return item.selected = true;
                    return item.selected = false;
                });
            })
            // fetch theme from local storage
            .addCase(fetchTheme.fulfilled, (state, action) => {
                state.themes.map(item => {
                    if (item.id === +action.payload) return item.selected = true;
                    return item.selected = false;
                });
            })
    }
});

export const getThemes = state => state.utility.themes;
export const getActiveTheme = state => {
    const activeTheme = state.utility.themes.find(item => item.selected === true);
    return activeTheme ?  activeTheme : state.utility.themes[0];
};
export const {changeShowMenu,setLoading} = utilitySlice.actions;

export default utilitySlice.reducer;

